import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NewJobComponent } from './new-job.component';
import { DataPickerModule } from '../data-picker/data-picker.module';
import { ContactInfoFormModule } from '../contact-info/contact-info.module';
import { CustomFieldFormModule } from 'app/components/custom-field-form/custom-field-form.module';

@NgModule({
  declarations: [
    NewJobComponent
  ],
  imports: [
    SharedModule,
    ContactInfoFormModule,
    DataPickerModule,
    CustomFieldFormModule
  ],
  exports:[
    NewJobComponent
  ]
})
export class NewJobModule { }
